import React, { useState, useEffect } from "react";
import { useFetch} from "../../../../components/common/FetchProvider";
import Loader from "components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import InputField from "components/fields/InputField";


const AddCurrencyModal = ({ showModal, setModalState, refreshData }) => {
    const fetchWrapper = useFetch();
    const navigate = useNavigate();
    const [errorMessages, setErrorMessages] = useState({});
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({});

    const [formErrorData, setFormErrorData] = useState({});

    const handleInputChange = (event) => {
        errorMessages.message = "";
        setFormErrorData({});
        const { id, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const setErrorForField = (field) => {
        setFormErrorData({ [field]: "error" });
    }

    const errors = {
        registrationDate: "Please enter Data registrada",
        fromCurrency: "Please select De Moeda",
        toCurrency: "Please select Para Moeda",
        exchangeRate: "Please enter Valor do Câmbio",
        sameCurrency: "Da moeda para a moeda são iguais",
        apiError: "Something went wrong"
    };

    const validationRules = {
        registrationDate: {
            validate: (value) => value && value.length >= 3,
            message: errors.registrationDate,
        },
        fromCurrency: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.fromCurrency,
        },
        toCurrency: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.toCurrency,
        },
        exchangeRate: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.exchangeRate,
        },
    };

    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showModal]);

    const handleCancel = () => {
        setModalState(false);
    }

    const handleApprove = () => {
        for (let field in validationRules) {
            const { validate, message } = validationRules[field];
            if (!validate(formData[field])) {
                setErrorMessages({ name: field, message: message });
                setErrorForField(field);
                return;
            }
        }
        if(formData.fromCurrency === formData.toCurrency) {
            setErrorMessages({message: errors.sameCurrency})
            return;
        }

        setLoading(true);
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: JSON.stringify(formData)
        };

        fetchWrapper(process.env.REACT_APP_API_URL + "/v1/financial-management/exchange-rate", requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                if (data.responseInfo.status === "SUCCESS") {
                    refreshData();
                    setModalState(false);
                } else {
                    setErrorMessages({
                        name: "invalidCredentials",
                        message: errors.invalidCredentials,
                    });
                }
            });
    };


    return (
        <>
            {showModal ? (
                <>
                    <Loader show={loading} />
                    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
                        <div className="relative my-10 mx-auto w-full max-w-3xl sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2">
                            <div className="relative font-normal flex flex-col rounded-lg border-0 bg-white text-navy-800 shadow-lg outline-none focus:outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none">

                                {/* Modal Header */}
                                <div className="flex items-start justify-between rounded-t border-b border-solid p-5 border-slate-200">
                                    <h4 className="text-3xl font-semibold">Adicionar/editar Câmbio
                                    </h4>
                                </div>

                                {/* Modal Body */}
                                <div className="p-5 space-y-4">
                                    <div className="text-red-500 min-h-[1.30rem]">{errorMessages.message}</div>

                                    {/* Row 1: Payment Date with Calendar Icon and Document Number */}
                                    <div className="flex space-x-4 items-start">
                                        {/* Payment Date Field */}
                                                <InputField
                                                    variant="auth"
                                                    label="Data registrada"
                                                    id="registrationDate"
                                                    type="date"
                                                    state={formErrorData.registrationDate === "error" ? "error" : ""}
                                                    value={formData.registrationDate}
                                                    onChange={handleInputChange}
                                                />
                                                 <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">De Moeda</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${formErrorData.fromCurrency === "error" ? "border-red-500" : ""
                                                    }`}
                                                id="fromCurrency"
                                                value={formData.fromCurrency}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione moeda</option>
                                                <option value="USD">USD</option>
                                                <option value="JPY">JPY</option>
                                                <option value="EUR">EUR</option>
                                                <option value="AKZ">AKZ</option>
                                            </select>
                                        </div>
                                                <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">Para Moeda</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${formErrorData.toCurrency === "error" ? "border-red-500" : ""
                                                    }`}
                                                id="toCurrency"
                                                value={formData.toCurrency}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione moeda</option>
                                                <option value="USD">USD</option>
                                                <option value="JPY">JPY</option>
                                                <option value="EUR">EUR</option>
                                                <option value="AKZ">AKZ</option>
                                            </select>
                                        </div>
                                        <div className="w-full">
                                            <InputField
                                                variant="auth"
                                                label="Valor do Câmbio"
                                                id="exchangeRate"
                                                type="number"
                                                state={formErrorData.exchangeRate === "error" ? "error" : ""}
                                                value={formData.exchangeRate}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Modal Footer */}
                                <div className="flex items-center justify-end p-5 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        onClick={handleCancel}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                                        Cancelar
                                    </button>
                                    <button
                                        onClick={handleApprove}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 ml-auto"
                                    >
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </div>


                    </div>



                    {/*overlay*/}
                    <div className="bg-black opacity-90 fixed inset-0 z-40 backdrop-blur-2xl backdrop-filter"></div>
                </>
            ) : null}
        </>
    );
};

export default AddCurrencyModal;
